import { Injectable } from '@angular/core';
import { IRoutePlannerModel } from './core/models/models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  public routeModel: IRoutePlannerModel;
  constructor() {
    const browserWindow = window || {};
    const browserWindowEnv = browserWindow['__env'] || {};
    this.routeModel = browserWindowEnv;

    // Assign environment variables from browser window to env
    // In the current implementation, properties from env.js overwrite defaults from the EnvService.
    // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
    // for (const key in browserWindowEnv) {
    //   if (browserWindowEnv.hasOwnProperty(key)) {
    //     env[key] = window['__env'][key];
    //   }
    // }
  }

  get environment(): ENVIRONMENT {
    const hostname = window.location.hostname;
    if (hostname.indexOf('localhost') !== -1 ) {
      return ENVIRONMENT.LOCALHOST;
    } else if (hostname.indexOf('www.theaa.com') !== -1 ) {
      return ENVIRONMENT.PRODUCTION;
    } else {
      return ENVIRONMENT.DEVELOPMENT;
    }
  }

  get isProduction() {
    return (environment.production);
  }
}

export enum ENVIRONMENT {
  LOCALHOST = 'localhost',
  PRODUCTION = 'production',
  DEVELOPMENT = 'development',
}
